// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ExpandableClamp__label":"bbp_a bhp_hi bhp_sa bhp_xl"};